import gql from 'graphql-tag';

export const getCourses = gql`
  query getCourses {
    student {
      courses {
        id
        name
        code
        module
        classId
        professors {
          id
          code
          firstName
          lastName
        }
      }
    }
  }
`;

export const getCoursesSumary = gql`
  query GetCourseSummary($periodId: String!) {
    getCourseSummary(periodId: $periodId) {
      summary {
        campus
        enrolledCourses
        average
        relativeCycle
        creditCount
        meritOrder
        weeklyHours
        meritBelong
      }
      courses {
        courseId
        title
        catalogNumber
        approvalStatus
        professors
        teacher
        courseMode
        schedule {
          class
          courseId
          day
          endDate
          sectionId
          startDate
        }
        weeklyHours
        credits
        numberTimes
        section
        evaluations {
          name
          value
          shortName
        }
        module
        formula
        average
        relatedCourse {
          code
          description
        }
      }
    }
  }
`;

export const getEnrolledPeriodsByStudent = gql`
  query getEnrolledPeriodsByStudent {
    getPeriodsByStudent {
      id
      name
    }
  }
`;

export const getClassAttendance = gql`
  query getClassAttendance($period: String!, $classNbr: String!) {
    getClassAttendance(request: { periodId: $period, classNbr: $classNbr }) {
      summary {
        attended
        noAttended
        pending
        noRecord
      }
      months {
        name
        dates {
          name
          type
        }
      }
    }
  }
`;

export const progressiveCertificationEnabled = gql`
  query ProgressiveCertificationEnabled(
    $acadPlan: String!
    $prog: String!
    $carrer: String!
  ) {
    progressiveCertificationEnabled(
      acadPlan: $acadPlan
      prog: $prog
      carrer: $carrer
    )
  }
`;
